import React, { useEffect, useState } from 'react';

import MasonryLayout from './MasonryLayout';
import { client } from '../client';
import { feedQuery, searchQuery } from '../utils/data';
import Spinner from './Spinner';
import logo from '../assets/mk.gif'

const Search = ({ searchTerm }) => {
  const [pins, setPins] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchTerm !== '') {
      setLoading(true);
      const query = searchQuery(searchTerm.toLowerCase());
      client.fetch(query)
        .then((data) => {
        setPins(data);
        setLoading(false);
      });
    } else {
      client.fetch(feedQuery)
        .then((data) => {
        setPins(data);
        setLoading(true);
      });
    }
  }, [searchTerm]);

  return (
    <div>
      {loading && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '-50px' }}>
          <div style={{ marginLeft: '40px' }}>
            <Spinner message="Searching for pins..." />
          </div>
          <img src={logo} alt="Loading Image" />
        </div>
      )}
      {!loading && pins?.length !== 0 && <MasonryLayout pins={pins} />}
      {!loading && pins?.length === 0 && searchTerm !== '' && (
        <div className="mt-10 text-center text-xl">No Pins Found!</div>
      )}
    </div>
  );
};

export default Search;